import React, { useEffect, useState } from "react";
import classes from "./Message.css";

const message = (props) => {
  const displayMessage = props.info ? props.info.message : null;
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (!props.new) {
      setIsVisible(true);
      return undefined;
    }

    const timerInSeconds =
      props.timer === true ? 10 : Number(props.timer);
    const shouldAutoHide = Number.isFinite(timerInSeconds) && timerInSeconds > 0;

    setIsVisible(true);

    if (!shouldAutoHide) {
      return undefined;
    }

    const timeoutId = setTimeout(() => {
      setIsVisible(false);
      if (props.timeCallback) {
        props.timeCallback();
      }
    }, timerInSeconds * 1000);

    return () => clearTimeout(timeoutId);
  }, [displayMessage, props.new, props.timeCallback, props.timer]);

  const renderImage=()=>{
    if(props.msgType === "Error"){
      return <i className="fa fa-times-circle" style={{ fontSize: "20px", color: "red", marginRight:'10px' }} />
    } else if(props.msgType === "Success"){
      return <i className="fa fa-check-circle" style={{ fontSize: "20px", color: "green", marginRight:'10px' }} />
    }
    return null;
  }

  if (props.new && !isVisible) {
    return null;
  }

  if (props.new) {
    return (
      <div
        className={[
          classes.Message,
          classes[props.msgType+'New'],
          classes[props.position],
        ].join(" ")}
      >
        {renderImage()}
        {displayMessage}
      </div>
    );
  }

  return (
    <div
      className={[
        classes.Message,
        classes[props.msgType],
        classes[props.position],
      ].join(" ")}
    >
      {displayMessage}
    </div>
  );
};

export default message;
